// NPM Imports
import React from "react";
import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function NavBarItem(props) {
  const { item } = props;

  function isLinkActive() {
    if (Array.isArray(item.link))
      return item.link.some(obj => props.location.pathname === obj);
    return (
      props.location.pathname.includes(item.link) ||
      (props.location.pathname === "/templates" &&
        item.link === "/templates/library")
    );
  }
  return (
    <Link
      data-test={`top-navbar-item-${item.name}`}
      to={Array.isArray(item.link) ? item.link[0] : item.link}
      className={`navbar-item ${isLinkActive() ? "active" : ""}`}
      id={`top-navbar-item-${item.name}`}>
      {/* below span has been added for the notifications count only 
        {item.name === "INBOX" && props.newNotification ? (
          <span className="navbar-inbox-notificationdot" />
        ) : null} */}
      <i className="navbar-icon">
        <img
          src={isLinkActive() ? item.icoActive : item.ico}
          alt="icon"
          width="22px"
          height="22px"
        />
      </i>
      <span className="navbar-title">{item.tooltip}</span>
    </Link>
  );
}
